import eventbus from '../../utils/eventbus';

const CLS_POSITIVE = 'is-positive';
const CLS_NEGATIVE = 'is-negative';

const VALUE_DEFAULT = '—';

class TickerElement {
	constructor(el, { isin, underlyingKey, hasIndicator, feedProperty, previousValue = 0 } = {}) {
		this.el = el;
		this.valueEl = this.el.querySelector('[data-ref="value"]') || this.el;

		this.id = isin || underlyingKey;

		this.hasIndicator = hasIndicator;
		this.feedProperty = feedProperty;
		this.previousValue = previousValue;
		this.tickId = `tick:${this.id}`;

		this.onTick = this.onTick.bind(this);
		this.resetState = this.resetState.bind(this);
		this.onAnimationEnd = this.onAnimationEnd.bind(this);

		this.start();
	}

	start() {
		this.el.addEventListener('animationend', this.onAnimationEnd);
		eventbus.on(this.tickId, this.onTick);
	}

	destroy() {
		this.el.removeEventListener('animationend', this.onAnimationEnd);
		eventbus.off(this.tickId, this.onTick);
	}

	onTick(tick) {
		if (this.tickRequiresUpdate(tick)) {
			this.update(this.feedProperty, tick);
		}
	}

	tickRequiresUpdate(tick) {
		const feedPropertyValue = tick[this.feedProperty];
		const feedPropertyValueIsZero = feedPropertyValue === 0;

		return feedPropertyValue || feedPropertyValueIsZero;
	}

	onAnimationEnd() {
		this.resetState();
	}

	update(tickProperty, tick) {
		const value = tick[tickProperty];
		const valueFormatted = TickerElement.getFormattedValue(tick, tickProperty);

		this.valueEl.textContent = valueFormatted;

		if (this.hasIndicator) {
			if (value && value !== this.previousValue) {
				this.updateState(value);
			}

			this.previousValue = value;
		}
	}

	updateState(value) {
		const cssClass = value < this.previousValue ? CLS_NEGATIVE : CLS_POSITIVE;

		requestAnimationFrame(() => {
			this.el.classList.toggle(cssClass);
		});
	}

	resetState() {
		requestAnimationFrame(() => {
			this.el.classList.remove(CLS_POSITIVE);
			this.el.classList.remove(CLS_NEGATIVE);
		});
	}

	static getFormattedValue(tick, property) {
		const value = tick[property];
		const formattedValue = tick[`${property}Formatted`] || tick[property];

		if (!value) {
			return VALUE_DEFAULT;
		}

		return formattedValue;
	}
}

export default TickerElement;
